import { render, staticRenderFns } from "./NoiseBlocksTable.vue?vue&type=template&id=4db6581f&scoped=true"
import script from "./NoiseBlocksTable.vue?vue&type=script&lang=js"
export * from "./NoiseBlocksTable.vue?vue&type=script&lang=js"
import style0 from "./NoiseBlocksTable.vue?vue&type=style&index=0&id=4db6581f&prod&lang=css"
import style1 from "./NoiseBlocksTable.vue?vue&type=style&index=1&id=4db6581f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db6581f",
  null
  
)

export default component.exports